export const buildTime = '2026-10-07 15:06:01 UTC';
